import { Form, Formik } from "formik";
import React, { FC, ReactElement, useState } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { Controller } from "../../../../models/Controller";
import WizardSideBarStep from "../../../../models/WizardSideBarStep";
import { replaceController } from "../../../../services/executeCommandService";
import { getErrorMessage } from "../../../../services/utilities/ServiceError";
import { useDialog } from "../../../dialog/DialogContext";
import Wizard from "../../../wizard/wizard";
import SelectController from "../installMasterController/SelectController";
import Summary from "./Summary";

interface SwapMasterControllerModalProps {
    isOpen: boolean;
    onClose: () => void;
    postReplace: (status: string) => void;
    controllerToReplace: Controller;
    setBusy: (busy: boolean) => void;
    setBusyMessage: (message: string) => void;
}

const ReplaceMasterControllerModal : FC<SwapMasterControllerModalProps> = ({isOpen, onClose, postReplace, controllerToReplace, setBusy, setBusyMessage}) => {
    const { translate } = useLocale();
    const [currentStep, setCurrentStep] = useState(0);
    const [selectedDevice, setSelectedDevice] = useState<Controller>({
        name:'',
        id: 0
    });
    const dialog = useDialog();

    const onNext = () => {
        setCurrentStep(currentStep + 1)
    }

    const onBack = () => {
        setCurrentStep(currentStep - 1)
    }

    const newSteps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.selectController),
            description: selectedDevice.fixedAddress ?? translate.byKey(TranslationKeys.pending),
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: '',
            substeps: []
        }]

    const stepContent: ReactElement[] = [
        <SelectController key={`installStep-0`}
            selectedDevice={selectedDevice}
            setSelectedDevice={setSelectedDevice}
            onNext={onNext}
            filterInstalled={true}
            showLegend={false}
            title={translate.byKey(TranslationKeys.selectReplacementDevice)} />,
        <Summary key={`installStep-1`}
            onBack={onBack}
            controllerToReplace={controllerToReplace} />
    ]

    const swapController = (values) => {
        setBusyMessage(translate.byKey(TranslationKeys.replaceControllerMessage))
        setBusy(true)
        replaceController(controllerToReplace.fixedAddress ?? '', values.fixedAddress)
            .then((response) => {
                postReplace(response.status);
            })
            .catch((error) => {
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) })
            })
            .finally(() => {
                setBusy(false);
            })
    }

    return <>
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <Formik
                enableReinitialize={true}
                initialValues={selectedDevice}
                onSubmit={swapController}>
                <Form>
                    <Wizard
                        name={translate.byKey(TranslationKeys.replaceMasterController)}
                        step={currentStep}
                        onClose={onClose}
                        sidebarSteps={newSteps}>
                        {stepContent}
                    </Wizard>
                </Form>
            </Formik>
        </Modal>
    </>
}

export default ReplaceMasterControllerModal;
